import { normalizePath } from "@lib/tabs/route-utils";
import { useRouter } from "@tanstack/react-router";
import { useMemo } from "react";

export interface RouteSuggestion {
  path: string;
  title: string;
  description?: string;
  module?: string;
}

/**
 * Enumerates all real app routes that have a title, excluding dynamic routes.
 * Used by TicketRouteSelector for route autocomplete.
 */
export function useRouteSuggestions(): RouteSuggestion[] {
  const router = useRouter();

  return useMemo(() => {
    const suggestions: RouteSuggestion[] = [];
    for (const route of Object.values(router.routesById)) {
      const path = normalizePath(route._fullPath);
      const title = route.options?.staticData?.title;
      if (!title || path.includes("/$")) continue;
      suggestions.push({
        path,
        title,
        description: route.options?.staticData?.description,
        module: route.options?.staticData?.module,
      });
    }
    return suggestions.sort((a, b) => a.path.localeCompare(b.path));
  }, [router]);
}
